import { JsonPipe, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { Component, effect, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { BlockUIModule } from 'primeng/blockui';
import { Card } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Message } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { LoadingService } from './_core/_services/loading.service';
import { TranslatePipe } from '@ngx-translate/core';
import Keycloak, { KeycloakLogoutOptions } from 'keycloak-js';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    Card,
    RouterOutlet,
    Message,
    BlockUIModule,
    ProgressSpinnerModule,
    ToastModule,
    ConfirmDialogModule,
    TranslatePipe,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  loading = inject(LoadingService);
  keylcoak = inject(Keycloak);

  constructor(route: ActivatedRoute) {
    const originalLogout = this.keylcoak.logout.bind(this.keylcoak);
    this.keylcoak.logout = (options?: KeycloakLogoutOptions | undefined) => {
      return originalLogout(
        options ?? {
          redirectUri: window.location.origin + '/',
        },
      );
    };

    // const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
    // effect(() => {
    //   const keycloakEvent = keycloakSignal();
    //   console.log(keycloakEvent);
    //   if (keycloakEvent.type === KeycloakEventType.Ready) {
    //     const authenticated = typeEventArgs<ReadyArgs>(keycloakEvent.args);
    //   }
    //   if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
    //     const authenticated = false;
    //   }
    // });
  }

  ngOnInit() {
    registerLocaleData(localeIt, 'it-IT');
    localStorage.setItem('lang', 'it');

  }

}
